import { render, staticRenderFns } from "./AvatarImage.vue?vue&type=template&id=9ae9fa58&scoped=true&"
import script from "./AvatarImage.vue?vue&type=script&lang=js&"
export * from "./AvatarImage.vue?vue&type=script&lang=js&"
import style0 from "./AvatarImage.vue?vue&type=style&index=0&id=9ae9fa58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae9fa58",
  null
  
)

export default component.exports